/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import styled from '@themes/theme'
import { GlobalStoreKey } from '@v2/constants/common'
import _ from 'lodash'
import PrivateIco from '@shared/Icon/EtcIcon/PrivateIco'

const UserTitleWrap = styled.div`
  &.user-title {
    height: 20px;
    display: flex;
    align-items: center;
    .user-title {
      &--icon {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        margin-right: 4px;
      }
      &--txt {
        color: ${props => props.theme.color.darkTxt};
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.medium};
        display: flex;
        align-items: center;
        transition: color .3s;
        &.private {
          color: ${props => props.theme.color.disableTxt};
        }
        .private-mark {
          display: inline-block;
          height: 18px;
          width: auto;
          .fill {
            fill: ${props => props.theme.color.disableTxt};
          }
        }
      }
    }
  }
`

interface UserTitleProps {
  showSMark: boolean
  isSpecialMember: boolean
  userTitleId: number
  userTitleEnabled: boolean
  myPageMode: boolean
}

export const UserTitle: React.FC<UserTitleProps> = observer((props) => {
  const { globalStore, userStore } = useRootStore()
  const {
    showSMark,
    isSpecialMember,
    userTitleId,
    userTitleEnabled,
    myPageMode,
  } = props

  if (!myPageMode && !userTitleEnabled) {
    return
  }

  let titleTxt: string
  let titleImg: React.ReactElement

  const baseImageUrl = globalStore.findGlobalSetting(GlobalStoreKey.INGAME_IMAGES_URL).value + 'icon/user_title/'
  let imageUrl: string

  const initMarkImageAndTitle = () => {
    if (showSMark) {
      imageUrl = `${baseImageUrl}s_mark.jpg`
      titleTxt = 'S멤버십'
    } else if (!isSpecialMember && !_.isNil(userTitleId)) {
      const titleDef = userStore.userTitleDefMap[userTitleId]
      if (titleDef) {
        imageUrl = `${baseImageUrl}${titleDef.titleMarkFileName}`
        titleTxt = titleDef.title
      }
    }
  }

  if (myPageMode || userTitleEnabled) {
    initMarkImageAndTitle()
  }

  titleImg = <Fragment/>
  if (imageUrl) {
    titleImg = <img src={imageUrl} alt="마크" className="user-title--icon" loading="lazy"/>
  }

  let showPrivateMark = true
  if (_.isEmpty(titleTxt)) {
    showPrivateMark = false
  } else if (isSpecialMember && !showSMark) {
    showPrivateMark = false
  } else if (userTitleEnabled) {
    showPrivateMark = false
  }

  return (
    <UserTitleWrap className="user-title">
      {titleImg}
      <p className={showPrivateMark ? 'user-title--txt private' : 'user-title--txt'}>
        {titleTxt}
        {showPrivateMark && <span className="private-mark"><PrivateIco/></span>}
      </p>
    </UserTitleWrap>
  )
})
